<template>
  <div class="condition_query">
    <h1>{{ $t("tool.querytitle") }}</h1>
    <div class="form_com">
      <el-row class="search_com">
        <el-col :span="8" class="port_com">
          <span>{{ $t("tool.airlinesCode") }}</span>
          <el-input placeholder v-model="airlineCodes" clearable></el-input>
        </el-col>
        <el-col :span="8" class="port_com">
          <span>{{ $t("tool.zh") }}</span>
          <el-input placeholder v-model="chName" clearable></el-input>
        </el-col>
        <el-col :span="3">
          <el-button type="primary" class="query" @click="airlineQuery">{{ $t("home.book") }}</el-button>
        </el-col>
      </el-row>
      <el-table
        class="table_com"
        :data="airlineData"
        stripe
        style="width: 100%"
      >
        <el-table-column
          prop="carrier"
          label="Airline Code"
          width="68"
        ></el-table-column>
        <el-table-column
          prop="code3c"
          label="Code"
          width="116"
        ></el-table-column>
        <el-table-column
          prop="acName"
          label="Chinese Name of Airline"
          width="289"
        ></el-table-column>
        <el-table-column
          prop="acEname"
          label="English Name of Airline"
          width="285"
        ></el-table-column>
        <el-table-column
          prop="ctrycode"
          label="Country"
          width="80"
        ></el-table-column>
      </el-table>
    </div>
  </div>
</template>
<style type="text/css" scoped="true">
@import "~@/assets/css/view/tool/tool.css";
</style>
<script type="babel">
import YC_REQUEST_HANDLER from "@/api/request.js";
export default {
    data: function() {
        return {
            airlineCode: "",
            chName: "",
            airlineData: [
                {
                    carrier: "—",
                    acEname: "—",
                    acName: "—",
                    code3c: "—",
                    ctrycode: "—"
                }
            ]
        };
    },
    computed: {
        airlineCodes: {
            get: function() {
            return this.airlineCode;
            },
            set: function(val) {
            this.airlineCode = val.toUpperCase();
            }
        }
    },
    methods: {
        airlineQuery: function() {
            var vm = this;
            if (!vm.airlineCode) {
                vm.$bus.emit("commmon-notification", null, "The airline code cannot be empty");
            } else {
                var params = {
                    carrier: vm.airlineCode,
                    acName: vm.chName
                };
                var url = "/api/freight/tool/carrier/list";
                var successCallBack = function(res) {
                    var airlineDatas = res.carrierList;
                    vm.airlineData = airlineDatas ? airlineDatas : [];
                };
                var failCallBack = function(errcode, errmessage) {
                    vm.$bus.emit("common-error-handler", errmessage);
                };
                YC_REQUEST_HANDLER.postQuery(
                    url,
                    params,
                    successCallBack,
                    failCallBack
                );
            }
        }
    }
};
</script>
